import { useEffect, useMemo, useState } from "react";
import { fetchGallery } from "@/lib/api";

export default function useGallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    fetchGallery()
      .then((data) => {
        if (active) setItems(data);
      })
      .catch((e) => {
        if (active) setError(e);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { items, loading, error };
}

export function applyFilter(items, filter) {
  if (!filter || filter === "All") return items;
  if (filter === "Photography") return items.filter((i) => i.type === "photo");
  if (filter === "Video") return items.filter((i) => i.type === "video");
  return items.filter((i) => i.category === filter);
}

export function useFiltered(items, filter) {
  return useMemo(() => applyFilter(items, filter), [items, filter]);
}
